module.exports = __webpack_public_path__ + "static/media/icons8-twitter.8a8204b2.svg";